import React, { useEffect, useState, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
interface AuthContextType {
  isAuthenticated: boolean;
  login: (username: string, password: string) => boolean;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  login: () => false,
  logout: () => {}
});
export const useAuth = () => useContext(AuthContext);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Check authentication status on initial load
    const auth = localStorage.getItem('auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    setIsInitialized(true);
  }, []);
  const login = (username: string, password: string) => {
    // Simple authentication check - in a real app, this would be a server request
    if (username === 'uwejanssen' && password === 'Letmein@0815') {
      setIsAuthenticated(true);
      localStorage.setItem('auth', 'true');
      return true;
    }
    return false;
  };
  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('auth');
    navigate('/login');
  };
  // Don't render children until authentication is initialized
  if (!isInitialized) {
    return null; // Or a loading spinner if preferred
  }
  return <AuthContext.Provider value={{
    isAuthenticated,
    login,
    logout
  }} data-id="element-137">
      {children}
    </AuthContext.Provider>;
};